module.exports = __webpack_public_path__ + "img/apartments-icon-black.08b503a5.svg";